"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.postCompanyDocuments = void 0;
/**
 * Save file paths/locations for company document(s)
 */
var postCompanyDocuments = function (instance) {
    return function (id, body, config) {
        return instance.post("/users/companies/".concat(id, "/documents"), body, config);
    };
};
exports.postCompanyDocuments = postCompanyDocuments;
